import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class HanhTrangSoCourseAPI extends BaseAPI {}

export default new HanhTrangSoCourseAPI('v1/hanhtrangso-courses', 'Course')
